import React from 'react';
import type { PreFormattedTextProps } from './types';

export default function PreFormatMessage(props: PreFormattedTextProps) {
	const { text } = props;
	return (
		<div // eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={{
				__html: text,
			}}
		/>
	);
}
